// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Curry = require("bs-platform/lib/js/curry.js");

function count(pred, l) {
  return List.fold_left((function (total, v) {
                if (Curry._1(pred, v)) {
                  return total + 1 | 0;
                } else {
                  return total + 0 | 0;
                }
              }), 0, l);
}

exports.count = count;
/* No side effect */
